import { createContext, useCallback, useContext, useState } from 'react'
import { useBreakpoints } from '@10000/react'
import { Box } from '../widgets'
import { assetUrl } from '../../utilities.js'

const context = createContext({})

export const useBackground = () => useContext(context)

export const Background = ({ children }) => {
  const { mobile } = useBreakpoints()
  const [background, setBackground] = useState()
  const [size, setSize] = useState('cover')
  const [position, setPosition] = useState('center')
  const [opacity, setOpacity] = useState(0)
  const [fade, setFade] = useState(false)
  const [previous, setPrevious] = useState()

  const set = useCallback(options => {
    const { active, background: newBackground, size: newSize, position: newPosition, fade: newFade } = typeof options === 'function' ? options(mobile) : options

    if(active) {
      setTimeout(() => {
        if(newBackground !== background) {
          setPrevious({ background, size, position, fade, opacity: 1 })
          setTimeout(() => setPrevious({ background, size, position, fade, opacity: 0 }))
        }
        setBackground(newBackground)
        setSize(newSize)
        setPosition(newPosition)
        setFade(newFade)

        setOpacity(background ? 1 : 0)
      })
    }
  }, [background, size, position, fade, mobile])

  const renderBackground = ({ key, background, size, position, fade, opacity }) => (
    <Box
      key={key}
      position="absolute"
      style={{
        background: background && `${fade ? 'var(--black-fade), ' : ''}${background?.startsWith?.('var') ? background : `url(${assetUrl(`backgrounds/${background}.png`)})`} ${position || 'center'} / ${size || 'cover'} no-repeat`,
      }}
      width="100%"
      height="100%"
      opacity={opacity}
      transition={0.5}
    />
  )

  return (
    <context.Provider value={{ set }}>
      {renderBackground({ key: 'current', background, size, position, fade, opacity })}
      {previous && renderBackground({ key: 'previous', ...previous })}
      {children}
    </context.Provider>
  )
}